/* ===========================================================================
   El Rose — Letter selector ↔ gallery sync

   The "Letter" variant option renders as an A–Z scrubber (see
   elrose-letter-selector.liquid). Selecting a letter already picks the variant
   via Dawn's <variant-selects>; this bridges the one thing Dawn's swap doesn't
   do for our custom gallery — moving the hero image to the chosen letter.

   Each letter radio carries data-media-id (the variant's featured_media, set
   server-side). We jump the gallery to the thumb with that media id, which
   hands off to erb-gallery.js (hero swap, counter, mobile scroll). Keying on
   the media id — not alt text — keeps this correct as photos/alts change.
   =========================================================================== */
(function () {
  'use strict';

  function jumpToMediaId(mediaId) {
    if (!mediaId) return;
    var gallery = document.querySelector('[data-erb-gallery]');
    if (!gallery) return;
    var thumb = gallery.querySelector('[data-erb-thumb][data-media-id="' + mediaId + '"]');
    if (thumb) thumb.click();
  }

  function selectedRadio() {
    return document.querySelector('input[type="radio"][data-option-name="Letter"]:checked');
  }

  // Delegated so it survives Dawn re-rendering the picker on variant change.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][data-option-name="Letter"]')) {
      jumpToMediaId(t.dataset.mediaId);
    }
  });

  // Sync the hero to the pre-selected letter once the gallery is ready.
  function syncInitial() {
    var checked = selectedRadio();
    if (checked) jumpToMediaId(checked.dataset.mediaId);
  }
  var gallery = document.querySelector('[data-erb-gallery]');
  if (gallery) {
    if (gallery.dataset.erbInited === '1') {
      syncInitial();
    } else {
      gallery.addEventListener('erb:ready', syncInitial, { once: true });
    }
  }
})();
